import { useMemo } from 'react';
import './App.css';

import queryString from 'query-string';

import Form from './containers/form';
import HazardDisplay from './containers/hazard-display';


/**
 * If the argument show is part of the URL, we show the application
 * as a result page only (no form) but this assumes that the URL contains
 * all other required parameters.  Those parameters are listed in the AppStateProvider
 * initialValues field.
 */
const App = () => {
  // @ts-ignore: to make life simpler, we assume parameters are passing always
  const params = useMemo<HazardInputs>(() => {  
    const temp = queryString.parse(window.location.search);
    return {
      code: temp.code || 'nbc2020',
      model: temp.model,
      siteDesignation: temp.siteDesignation,
      siteDesignationXV: temp.siteDesignationXV,
      siteDesignationXS: temp.siteDesignationXS,
      latitude: Number(temp.latitude),
      longitude: Number(temp.longitude),
    }
  }, []);

  return (params.latitude && params.longitude) ? <HazardDisplay params={params}/> : <Form />;
}


export default App;